import Assets from './Assets';
import {TimeUnit} from './BillingPeriod';
import Localization from './Localization';

export default class SubscriptionArticles {
	_id: string;

	name: Localization;
	description?: Localization;
	image?: Assets;
	createdAt: string;
	// if useMasterFoodcard articles contains masterIds
	articles: string[];

	useMasterFoodcard: boolean;
	isActive?: boolean;
	maxPricePerOrder?: number;
	maxPricePerArticle?: number;
	maxArticlesPerOrder?: number;
	maxOrdersPerDay?: number;
	prices: {
		createdAt: string;
		id: string;
		period: {
			factor: number;
			unit: TimeUnit;
		};
		price: {$numberDecimal: string};
		updatedAt: string;
	}[];
	renewsAt?: string;
	automaticallyRenew: boolean;
}
